import Swiper from 'swiper'
// O import "swiper" traz só o core: sem registrar Navigation em `modules`,
// a config `navigation` abaixo seria silenciosamente ignorada e as setas
// não funcionariam.
import { Navigation } from 'swiper/modules'
import { find } from 'utils/dom'

export default function () {
	const Home = find("[js-page='home']")
	if (!Home) return

	console.log('Page home')

	// Carrossel do time. slidesPerView é sempre fracionário de propósito: o pedaço
	// do próximo card cortado na borda é o que sinaliza que dá para arrastar.
	const swiperTime = new Swiper('.swiper-time', {
		modules: [Navigation],
		slidesPerView: 1.15,
		spaceBetween: 16,
		breakpoints: {
			601: { slidesPerView: 2.2, spaceBetween: 24 },
			1025: { slidesPerView: 4.25, spaceBetween: 32 },
		},
		navigation: {
			nextEl: '.swiper-button-next-time',
			prevEl: '.swiper-button-prev-time',
		},
	})
}
